export default "__VITE_ASSET__20df9041__"